import { useState, useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import EposRouter from "./routers/epos-router";
import EposRouterByIndustry from "./routers/epos-router-by-industry";
import TerminalsRouter from "./routers/terminals-router";
import { useAppContext } from "./AppContext";
import { Routing, Industries, POSSolutions } from "./file.interface";
import { MainContainer } from "./components/containers";

const baseUrl = "/" + window.location.pathname.split("/")[1] || "/";

const updateRouting = (dispatch: React.Dispatch<any>, routing: Routing) => {
  dispatch({
    type: "UPDATE_CONTEXT",
    payload: {
      routing: routing,
    },
  });
};

const updateRoutingByIndustry = (
  dispatch: React.Dispatch<any>,
  routing: Routing,
  industry: Industries
) => {
  dispatch({
    type: "UPDATE_CONTEXT",
    payload: {
      routing: routing,
      selectedIndustry: industry,
      selectedPOSSolution: POSSolutions.filter((solution) =>
        solution.industries.includes(industry)
      )[0],
    },
  });
};

interface Navigation {
  routes: string[];
  component: React.ReactNode;
  routing: Routing;
  industry: Industries | null;
}

const navigation: Navigation[] = [
  {
    routes: [
      "/epos-calculator",
      "/calculator-draft",
      "/customized-epos-system",
      "/customised-epos-system",
    ],
    component: <EposRouter />,
    routing: Routing.Epos,
    industry: null,
  },
  {
    routes: ["/card-machine-calculator"],
    component: <TerminalsRouter />,
    routing: Routing.Terminals,
    industry: null,
  },
  {
    routes: ["/epos-for-hair-and-beauty"],
    component: <EposRouterByIndustry />,
    routing: Routing.EposByIndustry,
    industry: Industries.Hairdresser,
  },
  {
    routes: ["/epos-system-for-hospitality"],
    component: <EposRouterByIndustry />,
    routing: Routing.EposByIndustry,
    industry: Industries.Restaurant,
  },
  {
    routes: ["/epos-for-retail"],
    component: <EposRouterByIndustry />,
    routing: Routing.EposByIndustry,
    industry: Industries.Store,
  },
  {
    routes: ["/epos-solution-for-healthcare"],
    component: <EposRouterByIndustry />,
    routing: Routing.EposByIndustry,
    industry: Industries.Doctor,
  },
  /*   {
    routes: ["/customised-epos-system"],
    component: <EposRouterByIndustry />,
    routing: Routing.EposByIndustry,
    industry: Industries.Custom,
  }, */
];

const App: React.FC<{ baseUrlAttribute: string; homeButtonLabel: string }> = ({
  baseUrlAttribute,
  homeButtonLabel,
}) => {
  const { dispatch, showModal } = useAppContext();
  const [routerComponent, setRouterComponent] = useState<Navigation | null>(
    null
  );

  useEffect(() => {
    //console.log("quionda desde useffect");
    if (baseUrl === baseUrlAttribute) {
      navigation.forEach((item) => {
        let routeMatched = item.routes.includes(baseUrl);
        if (routeMatched) {
          if (item.industry) {
            updateRoutingByIndustry(dispatch, item.routing, item.industry);
          } else {
            updateRouting(dispatch, item.routing);
          }
          setRouterComponent(item);
        }
      });
    }
  }, []);

  if (baseUrl !== baseUrlAttribute) {
    return <div>INCORRECT BASE NAME</div>;
  }
  const startApp = () => {
    dispatch({
      type: "UPDATE_CONTEXT",
      payload: {
        showModal: !showModal,
      },
    });
  };

  return (
    <>
      <button onClick={startApp}>{homeButtonLabel}</button>
      {showModal && (
        <MainContainer>
          <BrowserRouter basename={baseUrlAttribute}>
            {routerComponent?.component}
          </BrowserRouter>
        </MainContainer>
      )}
    </>
  );
};

export default App;
